import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from 'app/shared/services/config';
import { FtpSweepModel } from '../models/ftp-sweep';
import { ApiResponse } from '../models/units';

@Injectable({
    providedIn: 'root',
})
export class FTPService {
    constructor(private http: HttpClient) {}

    public getFtpServers(cid: number) {
        return this.http.get<Array<FtpSweepModel>>(`${Config.serviceUrl}${Config.urls.ftpsweep.allServers}/?cid=${cid}`);
    }

    public deleteFtpServer(cid: number, guid: string) {
        return this.http.delete<ApiResponse<void>>(`${Config.serviceUrl}${Config.urls.ftpsweep.server}/?cid=${cid}&guid=${guid}`);
    }
    public updateFtpServer(cid: number, serverOpts: FtpSweepModel) {
        return this.http.post<void>(`${Config.serviceUrl}${Config.urls.ftpsweep.server}/?cid=${cid}`, serverOpts);
    }
}
